const filterDropdown = document.querySelector('.filter-dropdown')
//const filterCategoryContainer = document.querySelector('.filter-category-container')
const filterCategoryWrapper = document.querySelector('.filter-category-wrapper')
const modalClose = document.querySelector('.modal-close')
const body = document.querySelector('body')
const work_category = document.querySelectorAll('.work-category')

var heightSize = work_category.length * 50
 
if (filterDropdown){
    filterDropdown.addEventListener('click', () => {
        filterCategoryWrapper.classList.toggle('work-tags-show')

        if (!filterCategoryWrapper.classList.contains('work-tags-show')){
            filterCategoryWrapper.style.height = 0 + "px"
        }
        else{
            filterCategoryWrapper.style.height = heightSize + "px"
        }
        //filterCategoryContainer.classList.toggle('work-tags-show')
        //body.classList.toggle('disable-scroll')
    })
}

// if (modalClose){
//     modalClose.addEventListener('click', () => {
//         filterCategoryWrapper.classList.toggle('work-tags-show')
//         filterCategoryContainer.classList.toggle('work-tags-show')
//         body.classList.toggle('disable-scroll')
//     })
// }

// if (filterCategoryContainer){
//     filterCategoryContainer.addEventListener('click', () =>{

//         if (filterCategoryWrapper.classList.contains("work-tags-show")){
//             filterCategoryWrapper.classList.remove('work-tags-show')
//             body.classList.toggle('disable-scroll')
//         }

//         if (filterCategoryContainer.classList.contains("work-tags-show")){
//             filterCategoryContainer.classList.remove('work-tags-show')
//         }
//     })
// }

// if screen is mobile
work_category.forEach(cat => {
    cat.addEventListener('click', () => {
        if(window.innerWidth < 992){
            filterCategoryWrapper.classList.toggle('work-tags-show')

            if (!filterCategoryWrapper.classList.contains('work-tags-show')){
                filterCategoryWrapper.style.height = 0 + "px"
            }
            else{
                filterCategoryWrapper.style.height = heightSize + "px"
            }
            //filterCategoryContainer.classList.toggle('work-tags-show')
            //body.classList.toggle('disable-scroll')
        }
    })
})
